// Search
export const SET_SHOW_SEARCH = "SET_SHOW_SEARCH"
export const SET_SHOW_SEARCH_ICON = "SET_SHOW_SEARCH_ICON"